var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMembershipCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.302 17.11H3.698c-.54 0-1.011-.368-1.142-.892L.036 6.134a1.177 1.177 0 011.667-1.338L5.77 6.83l3.22-5.368a1.177 1.177 0 012.019 0l3.22 5.368 4.068-2.034a1.177 1.177 0 011.668 1.338l-2.521 10.084a1.177 1.177 0 01-1.142.891z",
    fill: "#FFD71B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.302 17.11c.54 0 1.01-.368 1.142-.892l2.52-10.084a1.177 1.177 0 00-1.667-1.338L14.23 6.83l-3.221-5.368A1.177 1.177 0 0010 .891v16.218h6.302z",
    fill: "#FFB700"
  })));
}

export default SvgMembershipCrown;